import React from 'react';
import './alert.css'
import { BaseComponent } from '../../base-component'
import { COMPONENT } from '../../ui-event'
import {genClassName} from '../../utils'


export default class Alert extends BaseComponent {
    state = {
        alertShow: false,
        title: '提示框标题',
        content: '提示框内容',
        confirmBtnTxt: '好的',
        cancelBtnTxt: '取消',
        singleBtn: false,
        cancelColor: '#8E8E8E',
        confirmColor: '#00B5AC',
        circleMode: false, // 边框圆形样式模式
        isHideOnConfirm: true  // 点击确定按钮时。是否隐藏弹窗
    }
    componentWillMount() {
        this.eventMgr.on(COMPONENT.ALERT.TOGGLE, (option) => {
            this.toggle();
            let {isHideOnConfirm} = option;
            if(!isHideOnConfirm){
                option.isHideOnConfirm = true;
            }
            this.setState(option)
        })
    }
    componentDidMount() {
        this.eventMgr.on(COMPONENT.ALERT.DESTROY, ()=>{
            this.setState({ alertShow: false });
        })
    }
  
    handleConfirm() {
        this.toggle('onConfirm');
        // let { onConfirm } = this.state;
        // onConfirm && onConfirm();
    }
    handleCancel() {
        this.toggle('onCancel');
        // let { onCancel } = this.state;
        // onCancel && onCancel();
    }
    toggle(type) {
        let { alertShow, isHideOnConfirm } = this.state;
        let clickEvent = this.state[type]
        if( type === 'onConfirm' && !isHideOnConfirm ){
            clickEvent && clickEvent();
            return '';
        }
        this.setState({ alertShow: !alertShow },()=>{
            clickEvent && clickEvent();
        })
    }
    render() {
        let { alertShow, title, content, confirmBtnTxt, cancelBtnTxt, singleBtn, cancelColor, confirmColor, circleMode } = this.state;

        let alertClasses = genClassName({
            'modal': true,
            'modal-hidden': !alertShow,
            'circle-mode': circleMode,
            'fix-Zindex': true
        })

        return (
            <div className={alertClasses}>
                <div className="alert">
                    {title &&
                        <div className="alert-title">
                            {title}
                        </div>
                    }
                    <div className="alert-content">
                        {content}
                    </div>
                    <div className="alert-button">
                        {!singleBtn &&
                            <div className="alert-cancel" style={{ color: cancelColor }} onClick={() => { this.handleCancel() }}>{cancelBtnTxt}</div>
                        }
                        <div className="alert-confirm" style={{ color: confirmColor }} onClick={() => { this.handleConfirm() }}>{confirmBtnTxt}</div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/alert/index.js